import { render, staticRenderFns } from "./TheoryExamUpdate.vue?vue&type=template&id=1f5b42cf&"
import script from "./TheoryExamUpdate.vue?vue&type=script&lang=ts&"
export * from "./TheoryExamUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports